<div class="layout-col full">
  <mat-toolbar elderTheme>
    <button mat-icon-button matDialogClose>
      <mat-icon>close</mat-icon>
    </button>

    <span>{{ 'settings.title' | translate }}</span>
  </mat-toolbar>

  <div class="flex layout-col gap-xl p-xl">
    <span>{{ 'context.timeslot' | translate }}</span>

    <div class="layout-row gap-sm">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'context.start' | translate }}</mat-label>
        <elder-local-time-input
          name="time-start"
          placeholder="{{ 'context.start' | translate }}"
          [(isoValue)]="slot.start"
        >
        </elder-local-time-input>
        <mat-error elderValidationError></mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'context.end' | translate }}</mat-label>
        <elder-local-time-input
          name="time-end"
          placeholder="{{ 'context.end' | translate }}"
          [(isoValue)]="slot.end"
        >
        </elder-local-time-input>
        <mat-error elderValidationError></mat-error>
      </mat-form-field>
    </div>

    <span>{{ 'Performance' | translate }}</span>

    <mat-slider [max]="20" [min]="0" [step]="0.05" [discrete]="true" [displayWith]="formatLabel">
      <input
        matSliderThumb
        [ngModel]="slot.performance"
        (ngModelChange)="slot.performance = $event"
      />
    </mat-slider>
  </div>

  <div class="flex-none layout-row place-between-center p-sm">
    <button mat-flat-button color="primary" (click)="onDelete($event)">Delete</button>

    <button mat-flat-button color="primary" (click)="onSave($event)">OK</button>
  </div>
</div>
